import { supabase } from "@/integrations/supabase/client"
import type { OAuthPlatform } from "./utils"

export async function initiateOAuth(platform: Exclude<OAuthPlatform, "bluesky">) {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error("User not authenticated")

  const { data, error } = await supabase.functions.invoke("oauth-initiate", {
    body: {
      platform,
      user_id: user.id,
      redirect_origin: window.location.origin,
    },
  })

  if (error) throw error
  if (!data?.success || !data?.authUrl) {
    throw new Error(data?.error || "Failed to get authorization URL")
  }
  return data as { success: true; authUrl: string; state: string }
}

export async function connectBluesky(handle: string, appPassword: string) {
  const { data, error } = await supabase.functions.invoke("bluesky-connect", {
    body: { handle, app_password: appPassword },
  })
  if (error) throw error
  if (!data?.success) {
    throw new Error(data?.error || "Bluesky connection failed")
  }
  return data as { success: true; handle: string; did: string }
}
